module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bubble-logo-02ee645c04145bd6f9c2e40f175dc651.svg";